<template>
  <v-icon :size="size">mdi-playlist-check</v-icon>
</template>

<script>
export default {
  name: "ListCheckIcon",
  props: {
    size: {
      type: String,
      default: '29px'
    }
  }
}
</script>

<style scoped>

</style>